<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-date-picker
        v-model="timeRange"
        type="datetimerange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        :default-time="['00:00:00', '23:59:59']"
        style="position: relative; top: 1px">
      </el-date-picker>
      <el-input prefix-icon="el-icon-search"
                clearable
                v-model="searchText"
                style="width: 260px; margin-left: 10px;"
                placeholder="工单号/车牌号/车主姓名"
                @input="debounceSearch"></el-input>
      <el-button style="margin-left: 10px" @click="search">查询</el-button>

      <el-button @click="exportData"><a :href="exportUrl">导出</a></el-button>
      <el-checkbox v-model="TimeTypeChecked" style="margin-left: 10px">交车日期导出</el-checkbox>
    </div>
    <el-table :data="workList_" v-loading="loading" header-cell-class-name="table-head" class="table-border">
      <el-table-column label="工单号" min-width="118">
        <template #default="{row}">
          <div>{{row.extraId || row.id}}</div>
        </template>
      </el-table-column>
      <el-table-column label="服务顾问" prop="consultantName"></el-table-column>
      <el-table-column label="客户姓名" prop="ownerName"></el-table-column>
      <el-table-column label="车牌号" prop="carNo"></el-table-column>
      <el-table-column label="开单时间" prop="enterTime" min-width="135"></el-table-column>
      <el-table-column label="预计交车时间" prop="estimateDeliveryTime" min-width="135"></el-table-column>
      <el-table-column label="实际交车时间" prop="deliveryTime" min-width="135"></el-table-column>
      <el-table-column label="单据状态">
        <template #default="{row}">
          <div>{{row.status | valueName('WorkStatus')}}</div>
        </template>
      </el-table-column>
      <el-table-column label="当前工序">
        <template #default="{row}">
          <div>{{row.procedureId | valueName('Procedure')}}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" :width="deletable ? 130 : 80" align="center" fixed="right">
        <template #default="{row}">
          <el-button type="text" @click="check(row)" size="mini">查看</el-button>
          <el-button v-if="deletable" type="text" @click="deleteWork(row)" size="mini" class="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center; margin-top: 10px">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <detail-work-dialog :visible.sync="dialog.showDetailWork" :work-id="dialog.workId"
                        pattern="READ_WORK"></detail-work-dialog>
  </div>
</template>

<script>
  import { deleteWork, historyWorks } from '@/utils/request'
  import DetailWorkDialog from '@/views/kanban/dialog/add-check/DetailWorkDialog'
  import { shareDataMixin } from '@/views/mixins/ShareData'
  import authority from '@/utils/authority'

  const lodash = require('lodash')

  export default {
    name: 'HistoryWork',
    mixins: [shareDataMixin],
    components: { DetailWorkDialog },
    data () {
      return {
        TimeTypeChecked: false,
        loading: false,
        searchText: null,
        workList: [],
        total: 0,
        pageSize: 10,
        currentPage: 1,
        timeRange: null,
        pickerOptions: {
          disabledDate (time) {
            return time.getLocalDays() > new Date().getLocalDays()
          }
        },
        dialog: {
          workId: '',
          showDetailWork: false
        }
      }
    },
    created () {
      this.search()
      this.Typelabel = this.TimeTypes[0].value
    },
    methods: {
      check (work) {
        this.dialog.workId = work.id
        this.dialog.showDetailWork = true
      },
      deleteWork (work) {
        this.$confirm(`确认删除车牌号【${work.carNo}】的工单, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteWork(work.id).then(() => {
            for (const i in this.workList) {
              if (this.workList[i].id === work.id) {
                this.workList.splice(i, 1)
                break
              }
            }
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      search () {
        this.loading = true
        const begTimeSec = this.timeRange ? this.timeRange[0].getTime() / 1000 : null
        const endTimeSec = this.timeRange ? this.timeRange[1].getTime() / 1000 : null
        historyWorks(this.currentPage, this.pageSize, begTimeSec, endTimeSec, this.searchText).then(response => {
          this.workList = response.data.workList
          this.total = response.data.total
        }).finally(() => {
          this.loading = false
        })
      },
      debounceSearch: lodash.debounce(function () {
        this.currentPage = 1
        this.search()
      }, 800),
      handleSizeChange (val) {
        this.pageSize = val
        this.search()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.search()
      },
      exportData () {
        window.location.href = this.exportUrl
      }
    },
    computed: {
      workList_ () {
        if (!this.searchText) return this.workList

        return this.workList
      },
      deletable () {
        if (this.isRoot) return true
        return this.$hasPermission(authority.DELETE_WORK)
      },
      exportUrl () {
        let url = this.$baseUrl + 'api/downloadHistoryWorks?'
        if (this.TimeTypeChecked === true) {
            url += 'timeType=1'
        } else {
            url += 'timeType=0'
        }
        if (this.timeRange) {
          url += '&begTime=' + this.timeRange[0].getTime() / 1000
          url += '&endTime=' + this.timeRange[1].getTime() / 1000
        }
        if (this.searchText) {
          url += '&searchText=' + this.searchText
        }
        return url
      }
    },
    watch: {
      timeRange () {
        this.currentPage = 1
        this.search()
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }
</style>
<style lang="scss">
//修改选中后文本的颜色
    .el-checkbox__input.is-checked+.el-checkbox__label{
    color:#606266!important;
    }
</style>
